import React, { useEffect, useState } from 'react';
import { 
  Box, Button, Tabs, Tab, Typography, CircularProgress
} from '@mui/material';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import { useAuth } from '../../components/AuthProvider';
import { useLoading } from '../../components/LoadingProvider';
import { useNavigate } from 'react-router-dom';

// Import components
import CategoriesList from './components/CategoriesList';
import AllDomainsTable from './components/AllDomainsTable';
import SyncDNSButton from './components/SyncDNSButton';

export default function BlacklistIndex() {
  const notify = useNotify();
  const auth = useAuth();
  const loading = useLoading();
  const navigate = useNavigate();
  const { isLoading, setLoading } = loading;
  
  const [tabValue, setTabValue] = useState(0); // 0 = categorias, 1 = todos domínios
  const [refresh, setRefresh] = useState(false);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Navigate to category detail page
  const handleCategorySelect = (categoryId) => {
    navigate(`/dns_blacklist/category/${categoryId}`);
  };

  React.useEffect(() => {
    document.title = "IPV7 Tools - DNS Domínios Bloqueados"
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 100px)' }}>
      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
        >
          <Tab label="Categorias" />
          <Tab label="Todos os Domínios Bloqueados" />
        </Tabs>
      </Box>
      
      {/* Sync DNS Button - Available in both tabs */}
      {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <SyncDNSButton 
          onRefresh={() => setRefresh(!refresh)}
        />
      </Box> */}
      
      {/* Tab Panels */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        {/* Categories Tab */}
        {tabValue === 0 && (
          <CategoriesList 
            refresh={refresh}
            onCategorySelect={handleCategorySelect}
          />
        )}
        
        {/* All Domains Tab */}
        {tabValue === 1 && (
          <AllDomainsTable 
            refresh={refresh}
            onRefresh={() => setRefresh(!refresh)}
          />
        )}
      </Box>
    </Box>
  );
}